export default function XML_HowToUse() {
  return (
    <div>
      <h1>XML_HowToUse</h1>
      <p>This is the XML_HowToUse component.</p>
    </div>
  );
}